const shimmer = {
  backgroundImage: 'linear-gradient(90deg, #EDE9FE 25%, #F5F3FF 50%, #EDE9FE 75%)',
  backgroundSize: '936px 100%',
  animation: 'shimmer 1.4s infinite linear',
}

const Skeleton = ({ className = '', style }) => (
  <span className={`block rounded-md ${className}`} style={{ ...shimmer, ...style }} aria-hidden />
)

export default Skeleton
